import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import back from "../Assets/Back.svg";
import { useNavigate } from "react-router";
import Context from "../../context/Context";

const Terms = ({ setSettings }) => {
  const [data, setData] = useState();
  const navigate = useNavigate();
  const { buildType, isMobile } = useContext(Context);

  let count = 0;
  useEffect(() => {
    loadDetails();
  }, [isMobile]);

  const loadDetails = async () => {
    try {
      const data = await axios.get(
        isMobile
          ? `https://storage.googleapis.com/goviralcampaign/phone_tandc.json`
          : `${process.env.REACT_APP_PROFILE_TERMSANDCONDITION}.json`
      );
      setData(data.data);
    } catch (error) {
      console.log(error.message);
      //navigate("/error")
    }
  };

  return (
    <div className="widthController ">
      <div className="flex gap-[20px] items-center p-[20px] sticky top-0 header-bg">
        <img
          src={back}
          alt=""
          onClick={() => {
            navigate(-1);
          }}
          className=" w-[13px]"
        />
        <span className="text-large-medium   text-[#0F6ABE]">
          {data?.heading}
        </span>
      </div>
      <div className="flex flex-col text-[17px] bg-black px-[16px] pt-[30px]">
        <span className="pb-[10px] text-regular-medium">{data?.question}</span>
        <span className="pb-[17px] text-[#5073EF] text-[14px]">
          {data?.date}
        </span>
        <div className="flex flex-col text-regular text-[#CDCDCD]">
          {isMobile ? (
            <div className="text-left ol-default ul-default pb-[50px]">
              <div
                dangerouslySetInnerHTML={{ __html: data?.tandc }}
                className="flex flex-col gap-[12px]"
              />
            </div>
          ) : (
            <>
              {data &&
                data.termsAndConditions &&
                data.termsAndConditions.map((obj) => {
                  count++;
                  return (
                    <div className="flex">
                      <span>{count}.</span>
                      <span className="pb-[10px] pl-2">{obj.tandc}</span>
                    </div>
                  );
                })}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Terms;
